import { xGetFromToIndex } from "../x/index.js";
import { xyCheck } from "./xyCheck.js";
/**
 * Finds the max value in a zone
 * @param data - object that contains property x (an ordered increasing array) and y (an array).
 * @param options - options.
 * @returns max y on the specified range.
 */
export function xyMaxY(data, options = {}) {
    xyCheck(data);
    const { x, y } = data;
    const { fromIndex, toIndex } = xGetFromToIndex(x, options);
    let currentxyMaxY = y[fromIndex];
    for (let i = fromIndex; i <= toIndex; i++) {
        if (y[i] > currentxyMaxY)
            currentxyMaxY = y[i];
    }
    return currentxyMaxY;
}
//# sourceMappingURL=xyMaxY.js.map